export interface IframeMessage {
  event: string;
  data?: any;
}

export function postIframeMessage(message: IframeMessage): void {
  window.parent.postMessage(message, '*');
}
